<template>
	<div class="border-box-6" :ref="ref">
    <svg class="border-svg-container" :width="mergedWidth" :height="mergedHeight">
      <path :d="`M 0 0 L ${mergedWidth} 0 L ${mergedWidth} ${mergedHeight} L ${mergedWidth / 3  * 2 + 4} ${mergedHeight} L ${mergedWidth / 3 * 2} ${mergedHeight - 6} L ${mergedWidth / 3 * 1+4} ${mergedHeight - 6} L ${mergedWidth/3*1} ${mergedHeight} L 0 ${mergedHeight} L 0 0 Z`" :fill="backgroundColor" :stroke="mergedColor[0]"/>
      <path :d="`M ${mergedWidth / 3 * 1 + 4} ${mergedHeight-2} L ${mergedWidth / 3 * 2} ${mergedHeight-2}`" :stroke="mergedColor[0]" stroke-width="2"/>
    </svg>
    <div class="border-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/src/mixin/autoResize'
import { deepMerge } from '@jiaminghi/charts/lib/util/index'
import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'
export default {
  name: 'BorderBox6',
  mixins: [autoResize],
  props: {
    color: {
      type: Array,
      default: () => ([]),
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    boxWidth:{
      type:Number,
      default:0
    },
    boxHeight:{
      type:Number,
      default:0
    },
    resize:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      ref: 'border-box-6',
      defaultColor: ['#00d5ff', '#088ee3'],
      mergedColor: [],
      mergedWidth: 0,
      mergedHeight: 0,
    }
  },
  watch: {
    color() {
      const {mergeColor} = this
      mergeColor()
    },
    width:{
      immediate:true,
      deep:true,
      handler() {
        if (!this.boxWidth) {
          this.mergedWidth = this.width
        }
      }
    },
    boxWidth:{
      immediate:true,
      deep:true,
      handler(val) {
        if (val) {
          this.mergedWidth = val
        }
      }
    },
    resize(val) {
      if (val) {
        this.initWH()
      }
    },
    height:{
      immediate:true,
      deep:true,
      handler() {
        if (!this.boxHeight) {
          this.mergedHeight = this.height
        }
      }
    },
    boxHeight:{
      immediate:true,
      deep:true,
      handler(val) {
        if (val) {
          this.mergedHeight = val
        }
      }
    }
  },
  methods: {
    mergeColor() {
      const {color, defaultColor} = this
      this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
    }
  },
  mounted() {
    const {mergeColor}=this
    mergeColor()
  },
}
</script>

<style scoped lang="less">
  .border-box-6{
    position: relative;
    width: 100%;
    height: 100%;

    .border-svg-container{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .border-box-content{
      position: relative;
      width: 100%;
      height: 100%;
      padding: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/border/border-box-6/main.vue